export default {
  list: {
    title: "Attività",
    descriptionAdmin: "Visualizza e crea attività per venditori e host",
    descriptionPartner: "Gestisci le tue attività, servizi e offerte",
    newActivity: "Nuova attività",
    loading: "Caricamento attività...",
    emptyTitle: "Nessuna attività trovata",
    emptyDescription: "Non hai ancora attività.",
    emptyDescriptionAdmin:
      "Crea un’attività per un venditore o un host per iniziare.",
    createFirst: "Crea la prima attività",
    createdToast: "Attività creata con successo!",
    errorLoad: "Impossibile caricare le attività",
    filterAria: "Filtra attività",
    filterAll: "Tutte",
    filterVisible: "Visibili",
    filterHidden: "Nascoste",
    searchPlaceholder: "Cerca per nome o città…",
    noMatchesTitle: "Nessuna attività corrispondente",
    noMatchesDescription: "Prova un'altra ricerca o mostra tutte le attività.",
    showAll: "Mostra tutte",
  },
  detail: {
    updatedToast: "Attività aggiornata con successo!",
    serviceCategoriesUpdated: "Categorie di servizio aggiornate",
    back: "Torna alle attività",
    goToPartner: "Vai al partner",
    staffPanelTitle: "Controlli staff",
    adminEditingBanner:
      "Stai modificando questa vetrina come staff. Le modifiche si applicano all'annuncio pubblicato del venditore.",
    adminCommissionTitle: "Commissione piattaforma",
    adminOnlyBadge: "Solo staff",
    adminCommissionHint:
      "Percentuale trattenuta dalla piattaforma sulle prenotazioni di questa attività. I venditori non vedono questa sezione.",
    adminCommissionPercentAria: "Percentuale commissione per questa attività",
    adminCommissionPercentInvalid: "Inserisci una percentuale valida.",
    adminCommissionEdit: "Modifica",
    adminCommissionToastSaved: "Commissione aggiornata.",
    adminCategoryTitle: "Tipo di attività",
    adminCategoryHint:
      "Se questa vetrina è un ristorante, un'attrazione o un servizio. I partner non possono modificarlo.",
    adminCategoryToastSaved: "Tipo di attività aggiornato.",
    adminSalesAgentTitle: "Agente di commercio",
    adminSalesAgentEmpty: "Non assegnato",
    adminSalesAgentChange: "Modifica",
    adminSalesAgentAssign: "Assegna",
    adminSalesAgentToastSaved: "Assegnazione agente aggiornata.",
    adminSalesAgentPercentInvalid:
      "Inserisci una percentuale di commissione valida.",
    adminSalesAgentModalAssignTitle: "Assegna agente",
    adminSalesAgentModalReassignTitle: "Cambia agente",
    adminPromoTitle: "Sconto promozionale",
    adminPromoActive: "Attivo",
    adminPromoEnabled: "Promozione attiva",
    adminPromoHint:
      "Imposta il margine minimo che la piattaforma mantiene su questa attività. Lo sconto viene interamente dal margine della piattaforma, quindi tutte le altre parti vengono pagate come se non ci fosse sconto. Lo sconto effettivo varia per articolo e per struttura.",
    adminPromoMarginMode: "Modalità margine minimo",
    adminPromoMarginModeAbsolute: "Importo fisso",
    adminPromoMarginModePercentage: "Percentuale del margine massimo",
    adminPromoMarginValueAbsolute: "Margine minimo della piattaforma (€)",
    adminPromoMarginValuePercentage: "Margine minimo (% del massimo)",
    adminPromoItemColumn: "Articolo",
    adminPromoPreviewHint:
      "Gli sconti variano per articolo e per struttura. I valori sotto sono per articolo su tutte le strutture raggiungibili.",
    adminPromoPreviewLoading: "Caricamento dati anteprima…",
    adminPromoNoItems:
      "Aggiungi articoli al catalogo per visualizzare in anteprima gli sconti risultanti.",
    adminPromoMaxMargin: "Margine max",
    adminPromoMinDiscount: "Sconto min",
    adminPromoMedianDiscount: "Sconto mediano",
    adminPromoMaxDiscount: "Sconto max",
    adminPromoOverrideColumn: "Override",
    adminPromoAddOverride: "Override",
    adminPromoRemoveOverride: "Rimuovi override",
    adminPromoSave: "Salva promozione",
    adminPromoRemove: "Rimuovi promozione",
    adminPromoToastSaved: "Promozione salvata.",
    adminPromoToastRemoved: "Promozione rimossa.",
    headerCommission: "Commissione {{percent}}",
    openStaffTab: "Apri impostazioni staff",
    adminActiveTitle: "Attività attiva",
    adminSalesAgentHint: "Agente che ha portato questa attività e la sua commissione.",
    adminPromoNotConfigured: "Non configurata",
    adminPromoPaused: "In pausa",
    adminPromoPreviewTitle: "Anteprima sconti per articolo",
    adminPromoPreviewEmpty: "Inserisci un margine minimo valido qui sopra per calcolare lo sconto di ogni articolo.",
    adminPromoPreviewError: "Impossibile calcolare l'anteprima degli sconti. Riprova tra poco.",
    adminPromoPriceColumn: "Prezzo",
    adminPromoOverrideCount_one: "{{count}} override",
    adminPromoOverrideCount_other: "{{count}} override",
    adminCatalogImportTitle: "Importa catalogo da PDF",
    adminCatalogImportBarHint:
      "Estrai item ed etichette da un PDF (anche scansionato), poi revisiona.",
    adminCatalogImportOpen: "Importa PDF",
    adminCatalogImportHint:
      "Carica un PDF di menu o catalogo — digitale o scansionato. Prima revisiona le etichette, poi assegnale agli item dal menu a tendina. Le etichette vengono salvate sull’attività alla conferma.",
    adminCatalogImportFileLabel: "Solo PDF",
    adminCatalogImportDropHint: "Clicca per scegliere un PDF",
    adminCatalogImportExtract: "Estrai item",
    adminCatalogImportSave: "Salva item",
    adminCatalogImportCancel: "Annulla",
    adminCatalogImportChooseAnother: "Scegli un altro PDF",
    adminCatalogImportPreviewCount: "{{count}} item da revisionare",
    adminCatalogImportLabelsTitle: "Etichette",
    adminCatalogImportLabelsHint:
      "Dal PDF e da questa attività. Rinominare aggiorna tutti gli item collegati. Puoi aggiungerne di nuove in qualsiasi momento.",
    adminCatalogImportLabelsEmpty:
      "Nessuna etichetta. Aggiungine una per assegnarla agli item.",
    adminCatalogImportAddLabelPlaceholder: "Nome nuova etichetta",
    adminCatalogImportRemoveLabel: "Rimuovi etichetta",
    adminCatalogImportLabelNameRequired: "Ogni etichetta deve avere un nome.",
    adminCatalogImportLabelDuplicate: "Questa etichetta esiste già.",
    adminCatalogImportLabelMissing: "Un item punta a un’etichetta rimossa.",
    adminCatalogImportLabelUntitled: "(senza nome)",
    adminCatalogImportName: "Nome",
    adminCatalogImportCategory: "Etichetta",
    adminCatalogImportCategoryNone: "Nessuna etichetta",
    adminCatalogImportDescription: "Descrizione",
    adminCatalogImportPrice: "Prezzo (€)",
    adminCatalogImportRemoveRow: "Rimuovi item",
    adminCatalogImportPickFile: "Seleziona prima un file PDF.",
    adminCatalogImportEmptyPreview:
      "Nessun item da salvare. Estrai di nuovo o annulla.",
    adminCatalogImportNameRequired: "Ogni item deve avere un nome.",
    adminCatalogImportPriceInvalid: "Inserisci un prezzo valido non negativo.",
    adminCatalogImportTranslatedBanner:
      "Il testo è stato tradotto in {{language}} per la revisione. Lingua rilevata: {{source}}.",
    adminCatalogImportToastExtracted:
      "Estratti {{count}} item. Revisiona prima di salvare.",
    adminCatalogImportToastSaved: "Aggiunti {{count}} item al catalogo.",
    visibilityLabel: "Visibilità nel catalogo",
    visibilityHint:
      "Acceso: visibile nel catalogo quando l’attività è attiva. Spento: nascosta, niente nuove prenotazioni. Salva per applicare.",
    visibilityToggleAria: "Mostra o nascondi questa attività nel catalogo",
    visibilityLockedHint:
      "Completa il profilo legale in Impostazioni prima di poter rendere visibile questa attività.",
    adminActiveHint:
      "Solo staff. Se disattivata, i partner non possono aprirla e non compare mai nel catalogo.",
    adminActiveToggleAria: "Attiva o disattiva questa attività (staff)",
    adminActiveToastSaved: "Stato attivo dell’attività aggiornato.",
    profileIncompleteBanner:
      "Il tuo profilo legale è incompleto. Questa attività non può comparire nel catalogo clienti finché il profilo non è completo.",
    profileIncompleteModalTitle: "Completa il profilo legale",
    profileIncompleteModalMessage:
      "Questa attività non può essere mostrata ai clienti finché il profilo legale non è completo. Vai in Impostazioni per inserire i dati richiesti oppure continua a modificare e completa il profilo più tardi.",
    profileIncompleteModalGoToProfile: "Vai al profilo",
    profileIncompleteModalLater: "Più tardi",
    partnerShareBadge: "{{percent}}% per prenotazione",
    partnerShareHint:
      "Quota concordata con Flitrip su ogni prenotazione di questa attività.",
    untitledActivity: "Attività senza nome",
    loading: "Caricamento attività...",
    notFoundMessage:
      "L’attività richiesta non esiste oppure non hai i permessi per visualizzarla.",
    inactiveAdminBanner:
      "Questa attività è inattiva. I partner la vedono nell’elenco ma non possono aprirla finché non la attivi.",
    hiddenBanner:
      "Questa attività è nascosta dal catalogo. Attiva la visibilità e salva per mostrarla di nuovo.",
    tabs: {
      ariaLabel: "Sezioni configurazione attività",
      general: "Generale",
      generalDesc: "Nome, indirizzo e media",
      generalHeading: "Generale e vetrina",
      generalHint:
        "Nome e descrizione in tutte le lingue supportate, indirizzo, immagini e impostazioni. Salva le modifiche al profilo con la barra in basso.",
      availability: "Disponibilità",
      availabilityDesc: "Orari settimanali e eccezioni",
      availabilityHeading: "Disponibilità",
      availabilityHint:
        "Imposta fasce orarie settimanali ed eccezioni per festività o periodi speciali. Le modifiche si salvano subito.",
      configuration: "Configurazione",
      configurationDesc: "Impostazioni, menu e servizi",
      configurationHeading: "Configurazione attività",
      configurationHint:
        "Impostazioni per categoria, voci di menu o catalogo servizi. La maggior parte delle modifiche si salva subito alla conferma.",
      preview: "Anteprima",
      previewDesc: "Vetrina su tablet",
      previewHeading: "Anteprima vetrina",
      previewHint:
        "Vedi come questa attività appare sul tablet in sede. Le azioni di prenotazione sono disabilitate in anteprima.",
      staff: "Staff",
      staffDesc: "Commissione, agente e promo",
      staffHeading: "Impostazioni staff",
      staffHint: "Visibili solo allo staff. Ogni blocco si salva separatamente.",
    },
    preview: {
      title: "Anteprima vetrina",
      disclaimer:
        "Questa è un'anteprima di sola lettura della pagina pubblica del catalogo. Salva le modifiche al profilo nelle altre schede prima di verificare gli aggiornamenti qui.",
      openInNewTab: "Apri in una nuova scheda",
    },
  },
  detailForm: {
    catalogCopyTitle: "Nome e descrizione",
    descriptionTitle: "Descrizione",
    nameTitle: "Nome",
    nameLanguageCardAria: "Modifica nome in {{language}}",
    descriptionPlaceholder:
      "Descrivi la tua attività, i servizi offerti e le esperienze che i clienti possono aspettarsi...",
    descriptionHint:
      "Opzionale in bozza; obbligatoria in tutte le lingue prima di renderla visibile",
    descriptionCustomerBanner:
      "I clienti vedono i testi del catalogo nella loro lingua quando nome e descrizione sono compilati in tutte le lingue supportate.",
    descriptionLanguageCardAria: "Modifica descrizione in {{language}}",
    autoTranslateHint:
      "Nome e descrizione sono obbligatori in tutte le lingue (inglese, spagnolo, italiano, tedesco). Compila almeno una lingua, poi genera le traduzioni. Dopo un cambio nome, genera di nuovo per aggiornare le altre lingue.",
    autoTranslateGenerate: "Genera traduzioni",
    locationTitle: "Indirizzo",
    handshakeConfigTitle: "Conferma prenotazione",
    requiresHandshake: "Richiede handshake",
    requiresHandshakeHint:
      "Se attivato, le prenotazioni richiedono la conferma del venditore prima di essere finalizzate. I clienti selezioneranno una data/ora preferita e attenderanno la tua approvazione.",
    noteStrong: "Nota:",
    handshakeNote:
      "I servizi di questa attività useranno gli orari di apertura dell’attività per la pianificazione. I clienti possono avere un solo handshake attivo alla volta.",
    handshakeNoteRestaurant:
      "I clienti devono confermare la prenotazione con te prima che venga addebitata la quota di prenotazione. I clienti possono avere un solo handshake attivo alla volta.",
    bookingCutoffTitle: "Chiusura prenotazioni",
    bookingCutoffHint:
      "Quanto prima rispetto all’inizio di ogni fascia senza ora di fine le prenotazioni devono chiudersi. Le fasce con ora di fine restano prenotabili fino a quell’ora (il cutoff non si applica).",
    bookingCutoffLeadTime: "Anticipo",
    bookingCutoffUnitLabel: "Unità",
    bookingCutoffUnitMinutes: "minuti",
    bookingCutoffUnitHours: "ore",
    bookingCutoffExample:
      "Esempio: fascia delle 09:00 con 2 ore di anticipo — si può prenotare fino alle 07:00; dopo non risulta più disponibile.",
  },
  weekdays: {
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica",
  },
  schedule: {
    title: "Orari di disponibilità",
    weeklyTitle: "Orario settimanale",
    overridesTitle: "Eccezioni all’orario",
    addOverride: "Aggiungi eccezione",
    noOverrides:
      "Nessuna eccezione. Aggiungine una per festività o periodi speciali.",
    noSlotsClosed: "Nessuna fascia (chiuso)",
    addTimeSlot: "Aggiungi fascia oraria",
    copyScheduleTitle: "Copia orario del {{day}}",
    pasteScheduleTitle: "Incolla qui l’orario del {{day}}",
    deleteOverrideConfirm: "Eliminare questa eccezione?",
    closedBadge: "Chiuso",
    slotModal: {
      editTitle: "Modifica fascia oraria",
      addTitle: "Aggiungi fascia oraria",
      startRequired: "L’ora di inizio è obbligatoria",
      startTimeLabel: "Ora di inizio",
      duplicateStartError: "Un’altra fascia usa già quest’ora di inizio",
      startOnlyTitle: "Ora di inizio",
      startOnlySubtitle: "Un solo orario",
      startOnlyHint:
        "Gli ospiti possono prenotare questa fascia fino all’ora di inizio. Se è impostato un cutoff, si chiude quei minuti prima dell’inizio.",
      windowTitle: "Finestra oraria",
      windowSubtitle: "Inizio e fine",
      windowHint:
        "Gli ospiti possono prenotare questa fascia fino all’ora di fine. Il cutoff non si applica.",
      endTimeLabel: "Ora di fine",
      endRequired: "L’ora di fine è obbligatoria per una finestra oraria",
      endAfterStart: "L’ora di fine deve essere successiva all’inizio",
      overlapWarning:
        "Questa fascia si sovrappone a un’altra. Puoi salvarla comunque.",
      maxCapacityLabel: "Capienza massima (opzionale)",
      maxCapacityPlaceholder: "Lasciare vuoto per illimitato",
      maxCapacityHint: "Numero massimo di posti in questa fascia",
      mealTypeLabel: "Tipo di pasto (opzionale)",
      breakfast: "Colazione",
      lunch: "Pranzo",
      dinner: "Cena",
      aperitif: "Aperitivo",
      saveSlot: "Salva modifiche",
      addSlot: "Aggiungi fascia",
    },
    overrideModal: {
      titleAdd: "Aggiungi eccezione all’orario",
      titleEdit: "Modifica eccezione",
      nameLabel: "Nome",
      namePlaceholder: "es. vacanze di Natale",
      from: "Da",
      to: "A",
      status: "Stato",
      closedDuring: "Chiuso in questo periodo",
      markClosed: "Segna come chiuso",
      timeSlots: "Fasce orarie",
      addSlot: "Aggiungi fascia",
      noSlotsHint:
        "Nessuna fascia definita. Se vuoto, si usa l’orario settimanale.",
      saveChanges: "Salva modifiche",
      addOverrideBtn: "Aggiungi eccezione",
      nameDateRequired: "Nome e intervallo di date sono obbligatori",
      endAfterStart:
        "La data di fine deve essere successiva a quella di inizio",
    },
    toast: {
      updated: "Orario aggiornato",
      updateError: "Errore nell’aggiornamento dell’orario",
      overrideCreated: "Eccezione creata",
      overrideCreateError: "Errore nella creazione dell’eccezione",
      overrideUpdated: "Eccezione aggiornata",
      overrideUpdateError: "Errore nell’aggiornamento dell’eccezione",
      overrideDeleted: "Eccezione eliminata",
      overrideDeleteError: "Errore nell’eliminazione dell’eccezione",
      copiedDay: "Orario del {{day}} copiato",
      slotOverlapWarning:
        "Questa fascia si sovrappone a un’altra. È stata salvata comunque.",
    },
  },
  zod: {
    nameRequired: "Il nome è obbligatorio in tutte le lingue",
    descriptionRequired: "La descrizione è obbligatoria in tutte le lingue",
    allTranslationsRequired:
      "Le traduzioni sono obbligatorie in tutte le lingue",
    commissionPercentRequired: "La commissione piattaforma è obbligatoria",
    commissionPercentRange: "Inserisci una percentuale valida.",
    categoryRequired: "Seleziona una categoria di catalogo",
    paymentModelRequired: "Seleziona un tipo di pagamento",
    bookingCutoffInvalid: "Inserisci un numero intero (0 o superiore).",
    bookingCutoffRange:
      "L’anticipo deve essere entro i limiti consentiti (fino a 7 giorni).",
  },
  card: {
    active: "Attiva",
    inactive: "Inattiva",
    hidden: "Nascosta",
    notReadyYet: "Non ancora pronta",
    inactiveBlocked:
      "Questa attività non è ancora attiva. Riprova più tardi.",
    partnerShare: "{{percent}}% per prenotazione",
  },
  header: {
    paymentModelUpfront: "Pagamento anticipato",
    paymentModelReceiptBased: "A ricevuta",
  },
  createModal: {
    title: "Crea nuova attività",
    owner: "Proprietario",
    regionLabel: "Regione di pagamento *",
    chooseRegion: "Seleziona regione…",
    regionRequired: "Seleziona una regione di pagamento",
    searchOwnerLabel: "Cerca venditore o host",
    searchOwnerPlaceholder: "Digita per filtrare…",
    selectAccount: "Seleziona account *",
    chooseOwner: "Scegli proprietario…",
    noOwnersError: "Aggiungi prima un venditore o un host",
    partnerSuffix: "(venditore)",
    hostSuffix: "(host)",
    catalogCategory: "Categoria catalogo",
    activityName: "Nome attività",
    description: "Descrizione",
    descriptionPlaceholder: "Descrivi la tua attività...",
    location: "Indirizzo",
    commissionPercentLabel: "Provvigione piattaforma (%)",
    salesAgent: "Agente di commercio (contratto)",
    salesAgentSearchPlaceholder: "Digita un’email…",
    salesAgentNoResults: "Nessun agente corrisponde alla ricerca.",
    paymentModel: "Tipo di pagamento",
    paymentModelUpfront: "Pagamento anticipato",
    paymentModelUpfrontDesc: "I clienti pagano prima della visita.",
    paymentModelReceiptBased: "A ricevuta (flusso ristorante)",
    paymentModelReceiptBasedDesc:
      "Flusso tipo ristorante con caricamento ricevuta e cashback.",
    createActivity: "Crea attività",
    wizardNext: "Continua",
    wizardSkip: "Salta",
    wizardStepDetails: "Dettagli",
    wizardStepSalesAgent: "Agente di commercio",
    wizardStepCounter: "Passo {{current}} di {{total}}",
    withoutLocation: "Senza sede",
    noLocationSelectedMessage: "Questa attività non ha una sede.",
    wizardStep2Lead:
      "Seleziona un agente dall’elenco, o salta per continuare senza.",
    salesAgentCutPercentLabel: "Commissione agente (%)",
    salesAgentCutRequired:
      "Inserisci la commissione dell’agente quando ne selezioni uno.",
    wizardStep3Lead:
      "Inserisci un indirizzo per il geocoding, o indica che l’attività non ha sede fissa.",
    salesAgentListEmpty: "Nessun agente disponibile.",
  },
  adminCreate: {
    back: "Torna alle attività",
    backToPartner: "Torna al venditore",
    backToHost: "Torna all'host",
  },
  restaurantConfig: {
    title: "Configurazione ristorante",
    cuisineTypes: "Tipi di cucina",
    cuisinePlaceholder: "Seleziona tipi di cucina…",
    cuisineHint: "Seleziona uno o più tipi di cucina",
    avgPriceLabel: "Prezzo medio a persona (€)",
    avgPriceHint: "Costo medio a persona in euro",
    avgPricePlaceholder: "25",
  },
  serviceCategories: {
    title: "Categorie di servizio",
    addCategory: "Aggiungi categoria",
    emptyTitle: "Nessuna categoria ancora",
    emptyDescription: "Crea categorie per organizzare i servizi che offri",
    emptyTitleMenu: "Le portate standard sono pronte",
    emptyDescriptionMenu:
      "Antipasti, primi e le altre portate predefinite restano disponibili quando aggiungi i piatti. Aggiungi una categoria qui solo se ti serve un raggruppamento extra.",
    standardCoursesHint:
      "Le portate predefinite del menu restano disponibili quando aggiungi i piatti.",
    edit: "Modifica categoria",
    delete: "Elimina categoria",
    modalEditTitle: "Modifica categoria",
    modalAddTitle: "Aggiungi categoria",
    nameLabel: "Nome categoria",
    namePlaceholder: "es. Massaggi",
    saveChanges: "Salva modifiche",
    allTranslationsRequired: "Il nome è obbligatorio in tutte le lingue",
    fillOneLanguageFirst:
      "Inserisci il nome della categoria in almeno una lingua prima di generare le traduzioni.",
    autoTranslateHint:
      "Il nome della categoria è obbligatorio in tutte le lingue. Compila almeno una lingua, poi genera le traduzioni. Dopo un cambio nome, genera di nuovo per aggiornare le altre lingue.",
    autoTranslateGenerate: "Genera traduzioni",
    thisCategory: "questa categoria",
    deleteConfirm: "Eliminare «{{name}}»?",
  },
  media: {
    saveChangesError: "Impossibile salvare le modifiche ai media",
    uploadedCount: "{{count}} file caricati",
    deleted: "Media eliminato",
    deleteFailed: "Impossibile eliminare il file",
    arrowNavHint: "Usa le frecce ← → per navigare",
    prevTitle: "Precedente (←)",
    nextTitle: "Successivo (→)",
    deleteConfirmTitle: "Eliminare il media?",
    deleteConfirmMessage:
      "Il file verrà rimosso dall'attività. Questa azione non può essere annullata.",
    sectionTitle: "Immagini e video",
    autoSaveBadge: "Salvataggio automatico",
    sectionDescription:
      "Carica immagini e video che verranno mostrati ai clienti. Trascina le anteprime per riordinare.",
    emptyEditableTitle: "Aggiungi immagini o video",
    emptyEditableHint: "Clicca per selezionare i file",
    emptyReadOnly: "Nessun contenuto multimediale disponibile",
    thumbnailAlt: "Anteprima {{n}}",
    uploadingAlt: "Caricamento {{n}}",
    cropDescription:
      "Inquadra la foto per la galleria del tablet (16:9). Il centro tratteggiato mostra cosa restano nelle card home (4:3).",
  },
} as const;
